import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

export const Hero = styled.div`
  width: 100%;
  height: 462px;
  background-color: ${props => props.theme.color.primary};
  ${media.m`
    height: 422px;
  `}
`;

export const Logo = styled.img`
  width: auto;
  height: 100px;
  margin-top: 140px;
  ${media.m`
    width: 80px;
    height: 80px;
    margin-top: 120px;
  `}
`;

export const Title = styled.h1`
  color: ${props => props.theme.color.wfWhite};
  font-weight: 600;
  font-size: 1.8em;
  margin-bottom: 0;
  ${media.m`
    font-size: 1.6em;
  `}
`;

export const Description = styled.p`
  margin: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 640px;
  line-height: 1.4;
  font-size: 1.125em;
  margin: 10px 0 0 0;
  color: ${props => props.theme.color.wfWhite};
  ${media.m`
    font-size: 1em;
    padding: 0 10px;
  `}
`;
